import { KamiSama } from '@taxdown/kami-sama';
import { ScreenFormMap } from '@taxdown/kami-sama/dist/kamiSama/definition';
import { history } from 'Store';

export const getScreenName = (
  kamiSama: KamiSama | null,
  screens?: ScreenFormMap,
  url?: string
): string | undefined => {
  if (screens && kamiSama) {
    const screenName = Object.keys(screens).find(key => `${screens[key].path}` === url);
    if (screenName && !kamiSama?.getScreen(screenName)?.isShow()) {
      const nextScreen = kamiSama?.getScreen(screenName);
      history.replace(kamiSama.getScreenNext(nextScreen).getRenderForm().path);
      return kamiSama?.getScreenNext(nextScreen).getId();
    }
    return screenName;
  }
  return undefined;
};
